// extracted by mini-css-extract-plugin
export default {"guestbookForm":"guestbookForm__guestbookForm--AHYmV","recaptchaTerms":"guestbookForm__recaptchaTerms--dSWdP","submitBtnContainer":"guestbookForm__submitBtnContainer--J8wr0"};